/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

/* AUTH */
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';
export const VALIDATE_EMAIL = 'VALIDATE EMAIL';
export const VALIDATE_EMAIL_SUCCESS = 'VALIDATE EMAIL SUCCESS';
export const VALIDATE_EMAIL_ERROR = 'VALIDATE EMAIL ERROR';


/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = 'MENU_CHANGE_HAS_SUB_ITEM_STATUS';

/* USER */
export const USER_DETAIL = 'USER_DETAIL';
export const USER_DETAIL_SUCCESS = 'USER_DETAIL_SUCCESS';
export const USER_DETAIL_ERROR = 'USER_DETAIL_ERROR';

/* UPLOAD FILE */
export const UPLOAD_SET = 'UPLOAD_SET';
export const UPLOAD_SET_SUCCESS = 'UPLOAD_SET_SUCCESS';
export const UPLOAD_SET_ERROR = 'UPLOAD_SET_ERROR';
export const UPLOAD_RESET = 'UPLOAD_RESET';

/* VALIDATION_DOCUMENT_REVIEW */
export const VALIDATION_DOCUMENT_REVIEW_LIST = 'VALIDATION_DOCUMENT_REVIEW_LIST';
export const VALIDATION_DOCUMENT_REVIEW_LIST_SUCCESS = 'VALIDATION_DOCUMENT_REVIEW_LIST_SUCCESS';
export const VALIDATION_DOCUMENT_REVIEW_LIST_ERROR = 'VALIDATION_DOCUMENT_REVIEW_LIST_ERROR';
export const VALIDATION_DOCUMENT_REVIEW_PAGE_SET = 'VALIDATION_DOCUMENT_REVIEW_PAGE_SET';
export const VALIDATION_DOCUMENT_REVIEW_SEARCH_SET = 'VALIDATION_DOCUMENT_REVIEW_SEARCH_SET';
export const VALIDATION_DOCUMENT_REVIEW_SEARCH_CHANGE = 'VALIDATION_DOCUMENT_REVIEW_SEARCH_CHANGE';
export const VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT = 'VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT';
export const VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS = 'VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS';
export const VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR = 'VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR';
export const VALIDATION_DOCUMENT_REVIEW_ADD_SET = 'VALIDATION_DOCUMENT_REVIEW_ADD_SET';
export const VALIDATION_DOCUMENT_REVIEW_ADD_MODAL_SET = 'VALIDATION_DOCUMENT_REVIEW_ADD_MODAL_SET';
export const VALIDATION_DOCUMENT_REVIEW_ADD = 'VALIDATION_DOCUMENT_REVIEW_ADD';
export const VALIDATION_DOCUMENT_REVIEW_ADD_SUCCESS = 'VALIDATION_DOCUMENT_REVIEW_ADD_SUCCESS';
export const VALIDATION_DOCUMENT_REVIEW_ADD_ERROR = 'VALIDATION_DOCUMENT_REVIEW_ADD_ERROR';
export const VALIDATION_DOCUMENT_REVIEW_ADD_CHANGE = 'VALIDATION_DOCUMENT_REVIEW_ADD_CHANGE';
export const VALIDATION_DOCUMENT_REVIEW_DETAIL = 'VALIDATION_DOCUMENT_REVIEW_DETAIL';
export const VALIDATION_DOCUMENT_REVIEW_DETAIL_SUCCESS = 'VALIDATION_DOCUMENT_REVIEW_DETAIL_SUCCESS';
export const VALIDATION_DOCUMENT_REVIEW_DETAIL_ERROR = 'VALIDATION_DOCUMENT_REVIEW_DETAIL_ERROR';
export const VALIDATION_DOCUMENT_REVIEW_VIEW_MODAL_SET = 'VALIDATION_DOCUMENT_REVIEW_VIEW_MODAL_SET';
export const VALIDATION_DOCUMENT_REVIEW_EDIT_MODAL_SET = 'VALIDATION_DOCUMENT_REVIEW_EDIT_MODAL_SET';
export const VALIDATION_DOCUMENT_REVIEW_EDIT_SET = 'VALIDATION_DOCUMENT_REVIEW_EDIT_SET';
export const VALIDATION_DOCUMENT_REVIEW_EDIT_CHANGE = 'VALIDATION_DOCUMENT_REVIEW_EDIT_CHANGE';
export const VALIDATION_DOCUMENT_REVIEW_UPDATE = 'VALIDATION_DOCUMENT_REVIEW_UPDATE';
export const VALIDATION_DOCUMENT_REVIEW_UPDATE_SUCCESS = 'VALIDATION_DOCUMENT_REVIEW_UPDATE_SUCCESS';
export const VALIDATION_DOCUMENT_REVIEW_UPDATE_ERROR = 'VALIDATION_DOCUMENT_REVIEW_UPDATE_ERROR';
export const VALIDATION_DOCUMENT_REVIEW_VIEW_TAB_SET = 'VALIDATION_DOCUMENT_REVIEW_VIEW_TAB_SET';
export const VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET = 'VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET';
export const VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET_SUCCESS = 'VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET_SUCCESS';
export const VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET_ERROR = 'VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET_ERROR';
export const VALIDATION_DOCUMENT_REVIEW_UPLOAD_RESET = 'VALIDATION_DOCUMENT_REVIEW_UPLOAD_RESET';

/* SEARCH */
export const SEARCH_DOCUMENT_TYPE = 'SEARCH_DOCUMENT_TYPE';
export const SEARCH_DOCUMENT_TYPE_SUCCESS = 'SEARCH_DOCUMENT_TYPE_SUCCESS';
export const SEARCH_DOCUMENT_TYPE_ERROR = 'SEARCH_DOCUMENT_TYPE_ERROR';
export const SEARCH_EQUIPMENT_DELIVERY_ORDER = 'SEARCH_EQUIPMENT_DELIVERY_ORDER';
export const SEARCH_EQUIPMENT_DELIVERY_ORDER_SUCCESS = 'SEARCH_EQUIPMENT_DELIVERY_ORDER_SUCCESS';
export const SEARCH_EQUIPMENT_DELIVERY_ORDER_ERROR = 'SEARCH_EQUIPMENT_DELIVERY_ORDER_ERROR';
export const SEARCH_DELIVERY_ORDER_LINE_LOT = 'SEARCH_DELIVERY_ORDER_LINE_LOT';
export const SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS = 'SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS';
export const SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR = 'SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR';
export const SEARCH_DELIVERY_ORDER_LINE = 'SEARCH_DELIVERY_ORDER_LINE';
export const SEARCH_DELIVERY_ORDER_LINE_SUCCESS = 'SEARCH_DELIVERY_ORDER_LINE_SUCCESS';
export const SEARCH_DELIVERY_ORDER_LINE_ERROR = 'SEARCH_DELIVERY_ORDER_LINE_ERROR';
export const SEARCH_STATUS_REVIEW = 'SEARCH_STATUS_REVIEW';
export const SEARCH_STATUS_REVIEW_SUCCESS = 'SEARCH_STATUS_REVIEW_SUCCESS';
export const SEARCH_STATUS_REVIEW_ERROR = 'SEARCH_STATUS_REVIEW_ERROR';
export const SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL = 'SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL';
export const SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_SUCCESS = 'SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_SUCCESS';
export const SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_ERROR = 'SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_ERROR';
export const SEARCH_CATEGORY_MAINTENANCE_DELAY = 'SEARCH_CATEGORY_MAINTENANCE_DELAY';
export const SEARCH_CATEGORY_MAINTENANCE_DELAY_SUCCESS = 'SEARCH_CATEGORY_MAINTENANCE_DELAY_SUCCESS';
export const SEARCH_CATEGORY_MAINTENANCE_DELAY_ERROR = 'SEARCH_CATEGORY_MAINTENANCE_DELAY_ERROR';
export const SEARCH_HOSPITAL_SECTION = 'SEARCH_HOSPITAL_SECTION';
export const SEARCH_HOSPITAL_SECTION_SUCCESS = 'SEARCH_HOSPITAL_SECTION_SUCCESS';
export const SEARCH_HOSPITAL_SECTION_ERROR = 'SEARCH_HOSPITAL_SECTION_ERROR';
export const SEARCH_HOSPITAL_SERVICE = 'SEARCH_HOSPITAL_SERVICE';
export const SEARCH_HOSPITAL_SERVICE_SUCCESS = 'SEARCH_HOSPITAL_SERVICE_SUCCESS';
export const SEARCH_HOSPITAL_SERVICE_ERROR = 'SEARCH_HOSPITAL_SERVICE_ERROR';
export const SEARCH_REQUEST_TYPE = 'SEARCH_REQUEST_TYPE';
export const SEARCH_REQUEST_TYPE_SUCCESS = 'SEARCH_REQUEST_TYPE_SUCCESS';
export const SEARCH_REQUEST_TYPE_ERROR = 'SEARCH_REQUEST_TYPE_ERROR';
export const SEARCH_REQUEST_TYPE_DETAIL = 'SEARCH_REQUEST_TYPE_DETAIL';
export const SEARCH_REQUEST_TYPE_DETAIL_SUCCESS = 'SEARCH_REQUEST_TYPE_DETAIL_SUCCESS';
export const SEARCH_REQUEST_TYPE_DETAIL_ERROR = 'SEARCH_REQUEST_TYPE_DETAIL_ERROR';
export const SEARCH_PRIORITY = 'SEARCH_PRIORITY';
export const SEARCH_PRIORITY_SUCCESS = 'SEARCH_PRIORITY_SUCCESS';
export const SEARCH_PRIORITY_ERROR = 'SEARCH_PRIORITY_ERROR';
export const SEARCH_REQUEST_STATUS = 'SEARCH_REQUEST_STATUS';
export const SEARCH_REQUEST_STATUS_SUCCESS = 'SEARCH_REQUEST_STATUS_SUCCESS';
export const SEARCH_REQUEST_STATUS_ERROR = 'SEARCH_REQUEST_STATUS_ERROR';
export const SEARCH_REQUEST_PROCESS_TYPE = 'SEARCH_REQUEST_PROCESS_TYPE';
export const SEARCH_REQUEST_PROCESS_TYPE_SUCCESS = 'SEARCH_REQUEST_PROCESS_TYPE_SUCCESS';
export const SEARCH_REQUEST_PROCESS_TYPE_ERROR = 'SEARCH_REQUEST_PROCESS_TYPE_ERROR';
export const SEARCH_ACTION_REQUEST = 'SEARCH_ACTION_REQUEST';
export const SEARCH_ACTION_REQUEST_SUCCESS = 'SEARCH_ACTION_REQUEST_SUCCESS';
export const SEARCH_ACTION_REQUEST_ERROR = 'SEARCH_ACTION_REQUEST_ERROR';
export const SEARCH_HEALTH_REGISTRY_AGENCY = 'SEARCH_HEALTH_REGISTRY_AGENCY';
export const SEARCH_HEALTH_REGISTRY_AGENCY_SUCCESS = 'SEARCH_HEALTH_REGISTRY_AGENCY_SUCCESS';
export const SEARCH_HEALTH_REGISTRY_AGENCY_ERROR = 'SEARCH_HEALTH_REGISTRY_AGENCY_ERROR';
export const SEARCH_BMP_AGENCY = 'SEARCH_BMP_AGENCY';
export const SEARCH_BMP_AGENCY_SUCCESS = 'SEARCH_BMP_AGENCY_SUCCESS';
export const SEARCH_BMP_AGENCY_ERROR = 'SEARCH_BMP_AGENCY_ERROR';
export const SEARCH_RISK_TYPE = 'SEARCH_RISK_TYPE';
export const SEARCH_RISK_TYPE_SUCCESS = 'SEARCH_RISK_TYPE_SUCCESS';
export const SEARCH_RISK_TYPE_ERROR = 'SEARCH_RISK_TYPE_ERROR';
export const SEARCH_GHTF = 'SEARCH_GHTF';
export const SEARCH_GHTF_SUCCESS = 'SEARCH_GHTF_SUCCESS';
export const SEARCH_GHTF_ERROR = 'SEARCH_GHTF_ERROR';
export const SEARCH_DIAGNOSTIC_CLASS = 'SEARCH_DIAGNOSTIC_CLASS';
export const SEARCH_DIAGNOSTIC_CLASS_SUCCESS = 'SEARCH_DIAGNOSTIC_CLASS_SUCCESS';
export const SEARCH_DIAGNOSTIC_CLASS_ERROR = 'SEARCH_DIAGNOSTIC_CLASS_ERROR';
export const SEARCH_ISO = 'SEARCH_ISO';
export const SEARCH_ISO_SUCCESS = 'SEARCH_ISO_SUCCESS';
export const SEARCH_ISO_ERROR = 'SEARCH_ISO_ERROR';
export const SEARCH_GT_CERTIFICATE = 'SEARCH_GT_CERTIFICATE';
export const SEARCH_GT_CERTIFICATE_SUCCESS = 'SEARCH_GT_CERTIFICATE_SUCCESS';
export const SEARCH_GT_CERTIFICATE_ERROR = 'SEARCH_GT_CERTIFICATE_ERROR';
export const SEARCH_SERVICE_TYPE = 'SEARCH_SERVICE_TYPE';
export const SEARCH_SERVICE_TYPE_SUCCESS = 'SEARCH_SERVICE_TYPE_SUCCESS';
export const SEARCH_SERVICE_TYPE_ERROR = 'SEARCH_SERVICE_TYPE_ERROR';
export const SEARCH_BIOEQUIVALENCE = 'SEARCH_BIOEQUIVALENCE';
export const SEARCH_BIOEQUIVALENCE_SUCCESS = 'SEARCH_BIOEQUIVALENCE_SUCCESS';
export const SEARCH_BIOEQUIVALENCE_ERROR = 'SEARCH_BIOEQUIVALENCE_ERROR';

/* SEARCH_VEHICLE_TYPE */
export const SEARCH_VEHICLE_TYPE = 'SEARCH_VEHICLE_TYPE';
export const SEARCH_VEHICLE_TYPE_SUCCESS = 'SEARCH_VEHICLE_TYPE_SUCCESS';
export const SEARCH_VEHICLE_TYPE_ERROR = 'SEARCH_VEHICLE_TYPE_ERROR';

/* SEARCH_FREQUENCY_MTO */
export const SEARCH_FREQUENCY_MTO = 'SEARCH_FREQUENCY_MTO';
export const SEARCH_FREQUENCY_MTO_SUCCESS = 'SEARCH_FREQUENCY_MTO_SUCCESS';
export const SEARCH_FREQUENCY_MTO_ERROR = 'SEARCH_FREQUENCY_MTO_ERROR';

/* SEARCH_AMBULANCE_PLATE */
export const SEARCH_AMBULANCE_PLATE = 'SEARCH_AMBULANCE_PLATE';
export const SEARCH_AMBULANCE_PLATE_SUCCESS = 'SEARCH_AMBULANCE_PLATE_SUCCESS';
export const SEARCH_AMBULANCE_PLATE_ERROR = 'SEARCH_AMBULANCE_PLATE_ERROR';

/* SEARCH_AMBULANCE_CHASIS */
export const SEARCH_AMBULANCE_CHASIS = 'SEARCH_AMBULANCE_CHASIS';
export const SEARCH_AMBULANCE_CHASIS_SUCCESS = 'SEARCH_AMBULANCE_CHASIS_SUCCESS';
export const SEARCH_AMBULANCE_CHASIS_ERROR = 'SEARCH_AMBULANCE_CHASIS_ERROR';

/* SEARCH_AMBULANCE_CODE_IGSS */
export const SEARCH_AMBULANCE_CODE_IGSS = 'SEARCH_AMBULANCE_CODE_IGSS';
export const SEARCH_AMBULANCE_CODE_IGSS_SUCCESS = 'SEARCH_AMBULANCE_CODE_IGSS_SUCCESS';
export const SEARCH_AMBULANCE_CODE_IGSS_ERROR = 'SEARCH_AMBULANCE_CODE_IGSS_ERROR';

/* EQUIPMENT_SCHEDULE_MAINTENANCE */
export const EQUIPMENT_SCHEDULE_MAINTENANCE_LIST = 'EQUIPMENT_SCHEDULE_MAINTENANCE_LIST';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_LIST_SUCCESS = 'EQUIPMENT_SCHEDULE_MAINTENANCE_LIST_SUCCESS';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_LIST_ERROR = 'EQUIPMENT_SCHEDULE_MAINTENANCE_LIST_ERROR';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_PAGE_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_PAGE_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_CHANGE = 'EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_CHANGE';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT = 'EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS = 'EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR = 'EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_MODAL_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_MODAL_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_ADD = 'EQUIPMENT_SCHEDULE_MAINTENANCE_ADD';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_SUCCESS = 'EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_SUCCESS';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_ERROR = 'EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_ERROR';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_CHANGE = 'EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_CHANGE';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL = 'EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_SUCCESS = 'EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_SUCCESS';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_ERROR = 'EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_ERROR';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_VIEW_MODAL_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_VIEW_MODAL_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_MODAL_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_MODAL_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_CHANGE = 'EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_CHANGE';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE = 'EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE_SUCCESS = 'EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE_SUCCESS';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE_ERROR = 'EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE_ERROR';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_VIEW_TAB_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_VIEW_TAB_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET_SUCCESS = 'EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET_SUCCESS';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET_ERROR = 'EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET_ERROR';
export const EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_RESET = 'EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_RESET';

/* TASK */
export const TASK_LIST = 'TASK_LIST';
export const TASK_LIST_SUCCESS = 'TASK_LIST_SUCCESS';
export const TASK_LIST_ERROR = 'TASK_LIST_ERROR';
export const TASK_PAGE_SET = 'TASK_PAGE_SET';
export const TASK_DETAIL = 'TASK_DETAIL';
export const TASK_DETAIL_SUCCESS = 'TASK_DETAIL_SUCCESS';
export const TASK_DETAIL_ERROR = 'TASK_DETAIL_ERROR';
export const TASK_VIEW_MODAL_SET = 'TASK_VIEW_MODAL_SET';
export const TASK_DETAIL_LIST = 'TASK_DETAIL_LIST';
export const TASK_DETAIL_LIST_SUCCESS = 'TASK_DETAIL_LIST_SUCCESS';
export const TASK_DETAIL_LIST_ERROR = 'TASK_DETAIL_LIST_ERROR';
export const TASK_DETAIL_ADD = 'TASK_DETAIL_ADD';
export const TASK_DETAIL_ADD_SUCCESS = 'TASK_DETAIL_ADD_SUCCESS';
export const TASK_DETAIL_ADD_ERROR = 'TASK_DETAIL_ADD_ERROR';
export const TASK_DETAIL_ADD_CHANGE = 'TASK_DETAIL_ADD_CHANGE';
export const DELIVERY_PLAN_TASK_UPDATE = 'DELIVERY_PLAN_TASK_UPDATE';
export const DELIVERY_PLAN_TASK_UPDATE_SUCCESS = 'DELIVERY_PLAN_TASK_UPDATE_SUCCESS';
export const DELIVERY_PLAN_TASK_UPDATE_ERROR = 'DELIVERY_PLAN_TASK_UPDATE_ERROR';

/* TASK_EQUIPMENT */
export const TASK_EQUIPMENT_LIST_DELIVERY_PLAN = 'TASK_EQUIPMENT_LIST_DELIVERY_PLAN';
export const TASK_EQUIPMENT_LIST_DELIVERY_PLAN_SUCCESS = 'TASK_EQUIPMENT_LIST_DELIVERY_PLAN_SUCCESS';
export const TASK_EQUIPMENT_LIST_DELIVERY_PLAN_ERROR = 'TASK_EQUIPMENT_LIST_DELIVERY_PLAN_ERROR';

/* EQUIPMENT_MODEL */
export const EQUIPMENT_MODEL_UPDATE = 'EQUIPMENT_MODEL_UPDATE';
export const EQUIPMENT_MODEL_UPDATE_SUCCESS = 'EQUIPMENT_MODEL_UPDATE_SUCCESS';
export const EQUIPMENT_MODEL_UPDATE_ERROR = 'EQUIPMENT_MODEL_UPDATE_ERROR';

/* EQUIPMENT_UNIT */
export const EQUIPMENT_UNIT_UPDATE = 'EQUIPMENT_UNIT_UPDATE';
export const EQUIPMENT_UNIT_UPDATE_SUCCESS = 'EQUIPMENT_UNIT_UPDATE_SUCCESS';
export const EQUIPMENT_UNIT_UPDATE_ERROR = 'EQUIPMENT_UNIT_UPDATE_ERROR';

/* REQUEST */
export const REQUEST_LIST = 'REQUEST_LIST';
export const REQUEST_LIST_SUCCESS = 'REQUEST_LIST_SUCCESS';
export const REQUEST_LIST_ERROR = 'REQUEST_LIST_ERROR';
export const REQUEST_PAGE_SET = 'REQUEST_PAGE_SET';
export const REQUEST_SEARCH_SET = 'REQUEST_SEARCH_SET';
export const REQUEST_SEARCH_CHANGE = 'REQUEST_SEARCH_CHANGE';
export const REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT = 'REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT';
export const REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS = 'REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS';
export const REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR = 'REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR';
export const REQUEST_ADD_SET = 'REQUEST_ADD_SET';
export const REQUEST_ADD_MODAL_SET = 'REQUEST_ADD_MODAL_SET';
export const REQUEST_ADD = 'REQUEST_ADD';
export const REQUEST_ADD_SUCCESS = 'REQUEST_ADD_SUCCESS';
export const REQUEST_ADD_ERROR = 'REQUEST_ADD_ERROR';
export const REQUEST_ADD_CHANGE = 'REQUEST_ADD_CHANGE';
export const REQUEST_DETAIL = 'REQUEST_DETAIL';
export const REQUEST_DETAIL_SUCCESS = 'REQUEST_DETAIL_SUCCESS';
export const REQUEST_DETAIL_ERROR = 'REQUEST_DETAIL_ERROR';
export const REQUEST_VIEW_MODAL_SET = 'REQUEST_VIEW_MODAL_SET';
export const REQUEST_EDIT_MODAL_SET = 'REQUEST_EDIT_MODAL_SET';
export const REQUEST_EDIT_SET = 'REQUEST_EDIT_SET';
export const REQUEST_EDIT_CHANGE = 'REQUEST_EDIT_CHANGE';
export const REQUEST_UPDATE = 'REQUEST_UPDATE';
export const REQUEST_UPDATE_SUCCESS = 'REQUEST_UPDATE_SUCCESS';
export const REQUEST_UPDATE_ERROR = 'REQUEST_UPDATE_ERROR';
export const REQUEST_VIEW_TAB_SET = 'REQUEST_VIEW_TAB_SET';
export const REQUEST_UPLOAD_SET = 'REQUEST_UPLOAD_SET';
export const REQUEST_UPLOAD_SET_SUCCESS = 'REQUEST_UPLOAD_SET_SUCCESS';
export const REQUEST_UPLOAD_SET_ERROR = 'REQUEST_UPLOAD_SET_ERROR';
export const REQUEST_UPLOAD_RESET = 'REQUEST_UPLOAD_RESET';

/* REQUEST_DETAIL */
export const REQUEST_DETAIL_LIST = 'REQUEST_DETAIL_LIST';
export const REQUEST_DETAIL_LIST_SUCCESS = 'REQUEST_DETAIL_LIST_SUCCESS';
export const REQUEST_DETAIL_LIST_ERROR = 'REQUEST_DETAIL_LIST_ERROR';
export const REQUEST_DETAIL_PAGE_SET = 'REQUEST_DETAIL_PAGE_SET';
export const REQUEST_DETAIL_SEARCH_SET = 'REQUEST_DETAIL_SEARCH_SET';
export const REQUEST_DETAIL_SEARCH_CHANGE = 'REQUEST_DETAIL_SEARCH_CHANGE';
export const REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT = 'REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT';
export const REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS = 'REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS';
export const REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR = 'REQUEST_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR';
export const REQUEST_DETAIL_ADD_SET = 'REQUEST_DETAIL_ADD_SET';
export const REQUEST_DETAIL_ADD_MODAL_SET = 'REQUEST_DETAIL_ADD_MODAL_SET';
export const REQUEST_DETAIL_ADD = 'REQUEST_DETAIL_ADD';
export const REQUEST_DETAIL_ADD_SUCCESS = 'REQUEST_DETAIL_ADD_SUCCESS';
export const REQUEST_DETAIL_ADD_ERROR = 'REQUEST_DETAIL_ADD_ERROR';
export const REQUEST_DETAIL_ADD_CHANGE = 'REQUEST_DETAIL_ADD_CHANGE';
export const REQUEST_DETAIL_DETAIL = 'REQUEST_DETAIL_DETAIL';
export const REQUEST_DETAIL_DETAIL_SUCCESS = 'REQUEST_DETAIL_DETAIL_SUCCESS';
export const REQUEST_DETAIL_DETAIL_ERROR = 'REQUEST_DETAIL_DETAIL_ERROR';
export const REQUEST_DETAIL_VIEW_MODAL_SET = 'REQUEST_DETAIL_VIEW_MODAL_SET';
export const REQUEST_DETAIL_EDIT_MODAL_SET = 'REQUEST_DETAIL_EDIT_MODAL_SET';
export const REQUEST_DETAIL_EDIT_SET = 'REQUEST_DETAIL_EDIT_SET';
export const REQUEST_DETAIL_EDIT_CHANGE = 'REQUEST_DETAIL_EDIT_CHANGE';
export const REQUEST_DETAIL_UPDATE = 'REQUEST_DETAIL_UPDATE';
export const REQUEST_DETAIL_UPDATE_SUCCESS = 'REQUEST_DETAIL_UPDATE_SUCCESS';
export const REQUEST_DETAIL_UPDATE_ERROR = 'REQUEST_DETAIL_UPDATE_ERROR';
export const REQUEST_DETAIL_VIEW_TAB_SET = 'REQUEST_DETAIL_VIEW_TAB_SET';
export const REQUEST_DETAIL_UPLOAD_SET = 'REQUEST_DETAIL_UPLOAD_SET';
export const REQUEST_DETAIL_UPLOAD_SET_SUCCESS = 'REQUEST_DETAIL_UPLOAD_SET_SUCCESS';
export const REQUEST_DETAIL_UPLOAD_SET_ERROR = 'REQUEST_DETAIL_UPLOAD_SET_ERROR';
export const REQUEST_DETAIL_UPLOAD_RESET = 'REQUEST_DETAIL_UPLOAD_RESET';

/* AWARD */
export const AWARD_LIST = 'AWARD_LIST';
export const AWARD_LIST_SUCCESS = 'AWARD_LIST_SUCCESS';
export const AWARD_LIST_ERROR = 'AWARD_LIST_ERROR';
export const AWARD_PAGE_SET = 'AWARD_PAGE_SET';
export const AWARD_SEARCH_SET = 'AWARD_SEARCH_SET';
export const AWARD_SEARCH_CHANGE = 'AWARD_SEARCH_CHANGE';
export const AWARD_SEARCH_DELIVERY_ORDER_LINE_LOT = 'AWARD_SEARCH_DELIVERY_ORDER_LINE_LOT';
export const AWARD_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS = 'AWARD_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS';
export const AWARD_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR = 'AWARD_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR';
export const AWARD_ADD_SET = 'AWARD_ADD_SET';
export const AWARD_ADD_MODAL_SET = 'AWARD_ADD_MODAL_SET';
export const AWARD_ADD = 'AWARD_ADD';
export const AWARD_ADD_SUCCESS = 'AWARD_ADD_SUCCESS';
export const AWARD_ADD_ERROR = 'AWARD_ADD_ERROR';
export const AWARD_ADD_CHANGE = 'AWARD_ADD_CHANGE';
export const AWARD_DETAIL = 'AWARD_DETAIL';
export const AWARD_DETAIL_SUCCESS = 'AWARD_DETAIL_SUCCESS';
export const AWARD_DETAIL_ERROR = 'AWARD_DETAIL_ERROR';
export const AWARD_VIEW_MODAL_SET = 'AWARD_VIEW_MODAL_SET';
export const AWARD_EDIT_MODAL_SET = 'AWARD_EDIT_MODAL_SET';
export const AWARD_EDIT_SET = 'AWARD_EDIT_SET';
export const AWARD_EDIT_CHANGE = 'AWARD_EDIT_CHANGE';
export const AWARD_UPDATE = 'AWARD_UPDATE';
export const AWARD_UPDATE_SUCCESS = 'AWARD_UPDATE_SUCCESS';
export const AWARD_UPDATE_ERROR = 'AWARD_UPDATE_ERROR';
export const AWARD_VIEW_TAB_SET = 'AWARD_VIEW_TAB_SET';
export const AWARD_UPLOAD_SET = 'AWARD_UPLOAD_SET';
export const AWARD_UPLOAD_SET_SUCCESS = 'AWARD_UPLOAD_SET_SUCCESS';
export const AWARD_UPLOAD_SET_ERROR = 'AWARD_UPLOAD_SET_ERROR';
export const AWARD_UPLOAD_RESET = 'AWARD_UPLOAD_RESET';

/* AWARD_DETAIL */
export const AWARD_DETAIL_LIST = 'AWARD_DETAIL_LIST';
export const AWARD_DETAIL_LIST_SUCCESS = 'AWARD_DETAIL_LIST_SUCCESS';
export const AWARD_DETAIL_LIST_ERROR = 'AWARD_DETAIL_LIST_ERROR';
export const AWARD_DETAIL_PAGE_SET = 'AWARD_DETAIL_PAGE_SET';
export const AWARD_DETAIL_SEARCH_SET = 'AWARD_DETAIL_SEARCH_SET';
export const AWARD_DETAIL_SEARCH_CHANGE = 'AWARD_DETAIL_SEARCH_CHANGE';
export const AWARD_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT = 'AWARD_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT';
export const AWARD_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS = 'AWARD_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS';
export const AWARD_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR = 'AWARD_DETAIL_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR';
export const AWARD_DETAIL_ADD_SET = 'AWARD_DETAIL_ADD_SET';
export const AWARD_DETAIL_ADD_MODAL_SET = 'AWARD_DETAIL_ADD_MODAL_SET';
export const AWARD_DETAIL_ADD = 'AWARD_DETAIL_ADD';
export const AWARD_DETAIL_ADD_SUCCESS = 'AWARD_DETAIL_ADD_SUCCESS';
export const AWARD_DETAIL_ADD_ERROR = 'AWARD_DETAIL_ADD_ERROR';
export const AWARD_DETAIL_ADD_CHANGE = 'AWARD_DETAIL_ADD_CHANGE';
export const AWARD_DETAIL_DETAIL = 'AWARD_DETAIL_DETAIL';
export const AWARD_DETAIL_DETAIL_SUCCESS = 'AWARD_DETAIL_DETAIL_SUCCESS';
export const AWARD_DETAIL_DETAIL_ERROR = 'AWARD_DETAIL_DETAIL_ERROR';
export const AWARD_DETAIL_VIEW_MODAL_SET = 'AWARD_DETAIL_VIEW_MODAL_SET';
export const AWARD_DETAIL_EDIT_MODAL_SET = 'AWARD_DETAIL_EDIT_MODAL_SET';
export const AWARD_DETAIL_EDIT_SET = 'AWARD_DETAIL_EDIT_SET';
export const AWARD_DETAIL_EDIT_CHANGE = 'AWARD_DETAIL_EDIT_CHANGE';
export const AWARD_DETAIL_UPDATE = 'AWARD_DETAIL_UPDATE';
export const AWARD_DETAIL_UPDATE_SUCCESS = 'AWARD_DETAIL_UPDATE_SUCCESS';
export const AWARD_DETAIL_UPDATE_ERROR = 'AWARD_DETAIL_UPDATE_ERROR';
export const AWARD_DETAIL_VIEW_TAB_SET = 'AWARD_DETAIL_VIEW_TAB_SET';
export const AWARD_DETAIL_UPLOAD_SET = 'AWARD_DETAIL_UPLOAD_SET';
export const AWARD_DETAIL_UPLOAD_SET_SUCCESS = 'AWARD_DETAIL_UPLOAD_SET_SUCCESS';
export const AWARD_DETAIL_UPLOAD_SET_ERROR = 'AWARD_DETAIL_UPLOAD_SET_ERROR';
export const AWARD_DETAIL_UPLOAD_RESET = 'AWARD_DETAIL_UPLOAD_RESET';

/* DELIVERY_PLAN */
export const DELIVERY_PLAN_LIST = 'DELIVERY_PLAN_LIST';
export const DELIVERY_PLAN_LIST_SUCCESS = 'DELIVERY_PLAN_LIST_SUCCESS';
export const DELIVERY_PLAN_LIST_ERROR = 'DELIVERY_PLAN_LIST_ERROR';
export const DELIVERY_PLAN_PAGE_SET = 'DELIVERY_PLAN_PAGE_SET';
export const DELIVERY_PLAN_SEARCH_SET = 'DELIVERY_PLAN_SEARCH_SET';
export const DELIVERY_PLAN_SEARCH_CHANGE = 'DELIVERY_PLAN_SEARCH_CHANGE';
export const DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT = 'DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT';
export const DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS = 'DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS';
export const DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR = 'DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR';
export const DELIVERY_PLAN_ADD_SET = 'DELIVERY_PLAN_ADD_SET';
export const DELIVERY_PLAN_ADD_MODAL_SET = 'DELIVERY_PLAN_ADD_MODAL_SET';
export const DELIVERY_PLAN_ADD = 'DELIVERY_PLAN_ADD';
export const DELIVERY_PLAN_ADD_SUCCESS = 'DELIVERY_PLAN_ADD_SUCCESS';
export const DELIVERY_PLAN_ADD_ERROR = 'DELIVERY_PLAN_ADD_ERROR';
export const DELIVERY_PLAN_ADD_CHANGE = 'DELIVERY_PLAN_ADD_CHANGE';
export const DELIVERY_PLAN_DETAIL = 'DELIVERY_PLAN_DETAIL';
export const DELIVERY_PLAN_DETAIL_SUCCESS = 'DELIVERY_PLAN_DETAIL_SUCCESS';
export const DELIVERY_PLAN_DETAIL_ERROR = 'DELIVERY_PLAN_DETAIL_ERROR';
export const DELIVERY_PLAN_VIEW_MODAL_SET = 'DELIVERY_PLAN_VIEW_MODAL_SET';
export const DELIVERY_PLAN_EDIT_MODAL_SET = 'DELIVERY_PLAN_EDIT_MODAL_SET';
export const DELIVERY_PLAN_EDIT_SET = 'DELIVERY_PLAN_EDIT_SET';
export const DELIVERY_PLAN_EDIT_CHANGE = 'DELIVERY_PLAN_EDIT_CHANGE';
export const DELIVERY_PLAN_UPDATE = 'DELIVERY_PLAN_UPDATE';
export const DELIVERY_PLAN_UPDATE_SUCCESS = 'DELIVERY_PLAN_UPDATE_SUCCESS';
export const DELIVERY_PLAN_UPDATE_ERROR = 'DELIVERY_PLAN_UPDATE_ERROR';
export const DELIVERY_PLAN_VIEW_TAB_SET = 'DELIVERY_PLAN_VIEW_TAB_SET';
export const DELIVERY_PLAN_UPLOAD_SET = 'DELIVERY_PLAN_UPLOAD_SET';
export const DELIVERY_PLAN_UPLOAD_SET_SUCCESS = 'DELIVERY_PLAN_UPLOAD_SET_SUCCESS';
export const DELIVERY_PLAN_UPLOAD_SET_ERROR = 'DELIVERY_PLAN_UPLOAD_SET_ERROR';
export const DELIVERY_PLAN_UPLOAD_RESET = 'DELIVERY_PLAN_UPLOAD_RESET';

/* VEHICLE */
export const VEHICLE_LIST = 'VEHICLE_LIST';
export const VEHICLE_LIST_SUCCESS = 'VEHICLE_LIST_SUCCESS';
export const VEHICLE_LIST_ERROR = 'VEHICLE_LIST_ERROR';
export const VEHICLE_PAGE_SET = 'VEHICLE_PAGE_SET';
export const VEHICLE_DETAIL = 'VEHICLE_DETAIL';
export const VEHICLE_DETAIL_SUCCESS = 'VEHICLE_DETAIL_SUCCESS';
export const VEHICLE_DETAIL_ERROR = 'VEHICLE_DETAIL_ERROR';
export const VEHICLE_VIEW_MODAL_SET = 'VEHICLE_VIEW_MODAL_SET';
export const VEHICLE_ADD_MODAL_SET = 'VEHICLE_ADD_MODAL_SET';
export const VEHICLE_ADD = 'VEHICLE_ADD';
export const VEHICLE_ADD_SUCCESS = 'VEHICLE_ADD_SUCCESS';
export const VEHICLE_ADD_ERROR = 'VEHICLE_ADD_ERROR';
export const VEHICLE_ADD_CHANGE = 'VEHICLE_ADD_CHANGE';
export const VEHICLE_EDIT_MODAL_SET = 'VEHICLE_EDIT_MODAL_SET';
export const VEHICLE_EDIT_SET = 'VEHICLE_EDIT_SET';
export const VEHICLE_EDIT_CHANGE = 'VEHICLE_EDIT_CHANGE';
export const VEHICLE_UPDATE = 'VEHICLE_UPDATE';
export const VEHICLE_UPDATE_SUCCESS = 'VEHICLE_UPDATE_SUCCESS';
export const VEHICLE_UPDATE_ERROR = 'VEHICLE_UPDATE_ERROR';

/* TASK_EMPLOYEE */
export const TASK_EMPLOYEE_LIST = 'TASK_EMPLOYEE_LIST';
export const TASK_EMPLOYEE_LIST_SUCCESS = 'TASK_EMPLOYEE_LIST_SUCCESS';
export const TASK_EMPLOYEE_LIST_ERROR = 'TASK_EMPLOYEE_LIST_ERROR';
export const TASK_EMPLOYEE_ADD = 'TASK_EMPLOYEE_ADD';
export const TASK_EMPLOYEE_ADD_SUCCESS = 'TASK_EMPLOYEE_ADD_SUCCESS';
export const TASK_EMPLOYEE_ADD_ERROR = 'TASK_EMPLOYEE_ADD_ERROR';
export const TASK_EMPLOYEE_UPDATE = 'TASK_EMPLOYEE_UPDATE';
export const TASK_EMPLOYEE_UPDATE_SUCCESS = 'TASK_EMPLOYEE_UPDATE_SUCCESS';
export const TASK_EMPLOYEE_UPDATE_ERROR = 'TASK_EMPLOYEE_UPDATE_ERROR';
export const TASK_EMPLOYEE_MODAL_SET = 'TASK_EMPLOYEE_MODAL_SET';
export const TASK_EMPLOYEE_SELECTED_SET = 'TASK_EMPLOYEE_SELECTED_SET';

/* TASK_VEHICLE */
export const TASK_VEHICLE_LIST = 'TASK_VEHICLE_LIST';
export const TASK_VEHICLE_LIST_SUCCESS = 'TASK_VEHICLE_LIST_SUCCESS';
export const TASK_VEHICLE_LIST_ERROR = 'TASK_VEHICLE_LIST_ERROR';
export const TASK_VEHICLE_ADD = 'TASK_VEHICLE_ADD';
export const TASK_VEHICLE_ADD_SUCCESS = 'TASK_VEHICLE_ADD_SUCCESS';
export const TASK_VEHICLE_ADD_ERROR = 'TASK_VEHICLE_ADD_ERROR';
export const TASK_VEHICLE_UPDATE = 'TASK_VEHICLE_UPDATE';
export const TASK_VEHICLE_UPDATE_SUCCESS = 'TASK_VEHICLE_UPDATE_SUCCESS';
export const TASK_VEHICLE_UPDATE_ERROR = 'TASK_VEHICLE_UPDATE_ERROR';
export const TASK_VEHICLE_MODAL_SET = 'TASK_VEHICLE_MODAL_SET';
export const TASK_VEHICLE_SELECTED_SET = 'TASK_VEHICLE_SELECTED_SET';

/* EMPLOYEE */
export const EMPLOYEE_LIST = 'EMPLOYEE_LIST';
export const EMPLOYEE_LIST_SUCCESS = 'EMPLOYEE_LIST_SUCCESS';
export const EMPLOYEE_LIST_ERROR = 'EMPLOYEE_LIST_ERROR';
export const EMPLOYEE_PAGE_SET = 'EMPLOYEE_PAGE_SET';
export const EMPLOYEE_DETAIL = 'EMPLOYEE_DETAIL';
export const EMPLOYEE_DETAIL_SUCCESS = 'EMPLOYEE_DETAIL_SUCCESS';
export const EMPLOYEE_DETAIL_ERROR = 'EMPLOYEE_DETAIL_ERROR';
export const EMPLOYEE_VIEW_MODAL_SET = 'EMPLOYEE_VIEW_MODAL_SET';
export const EMPLOYEE_ADD_MODAL_SET = 'EMPLOYEE_ADD_MODAL_SET';
export const EMPLOYEE_ADD = 'EMPLOYEE_ADD';
export const EMPLOYEE_ADD_SUCCESS = 'EMPLOYEE_ADD_SUCCESS';
export const EMPLOYEE_ADD_ERROR = 'EMPLOYEE_ADD_ERROR';
export const EMPLOYEE_ADD_CHANGE = 'EMPLOYEE_ADD_CHANGE';
export const EMPLOYEE_EDIT_MODAL_SET = 'EMPLOYEE_EDIT_MODAL_SET';
export const EMPLOYEE_EDIT_SET = 'EMPLOYEE_EDIT_SET';
export const EMPLOYEE_EDIT_CHANGE = 'EMPLOYEE_EDIT_CHANGE';
export const EMPLOYEE_UPDATE = 'EMPLOYEE_UPDATE';
export const EMPLOYEE_UPDATE_SUCCESS = 'EMPLOYEE_UPDATE_SUCCESS';
export const EMPLOYEE_UPDATE_ERROR = 'EMPLOYEE_UPDATE_ERROR';

/* AMBULANCE */
export const AMBULANCE_LIST = 'AMBULANCE_LIST';
export const AMBULANCE_LIST_SUCCESS = 'AMBULANCE_LIST_SUCCESS';
export const AMBULANCE_LIST_ERROR = 'AMBULANCE_LIST_ERROR';
export const AMBULANCE_PAGE_SET = 'AMBULANCE_PAGE_SET';
export const AMBULANCE_SEARCH_SET = 'AMBULANCE_SEARCH_SET';
export const AMBULANCE_SEARCH_CHANGE = 'AMBULANCE_SEARCH_CHANGE';
export const AMBULANCE_DETAIL = 'AMBULANCE_DETAIL';
export const AMBULANCE_DETAIL_SUCCESS = 'AMBULANCE_DETAIL_SUCCESS';
export const AMBULANCE_DETAIL_ERROR = 'AMBULANCE_DETAIL_ERROR';
export const AMBULANCE_VIEW_MODAL_SET = 'AMBULANCE_VIEW_MODAL_SET';
export const AMBULANCE_MAINTENANCE_UPDATE = 'AMBULANCE_MAINTENANCE_UPDATE';
export const AMBULANCE_MAINTENANCE_UPDATE_SUCCESS = 'AMBULANCE_MAINTENANCE_UPDATE_SUCCESS';
export const AMBULANCE_MAINTENANCE_UPDATE_ERROR = 'AMBULANCE_MAINTENANCE_UPDATE_ERROR';
export const AMBULANCE_ADD_MODAL_SET = 'AMBULANCE_ADD_MODAL_SET';
export const AMBULANCE_ADD_CHANGE = 'AMBULANCE_ADD_CHANGE';

export * from './menu/actions';
export * from './settings/actions';
export * from './auth/actions';
export * from './user/actions';
export * from './upload/actions';
export * from './validation_document_review/actions';
export * from './equipment_schedule_maintenance/actions';
export * from './request/actions';
export * from './request_detail/actions';
export * from './task/actions';
export * from './task_equipment/actions';
export * from './search/actions';
export * from './award/actions';
export * from './award_detail/actions';
export * from './delivery_plan/actions';
export * from './vehicle/actions';
export * from './employee/actions';
export * from './task_employee/actions';
export * from './task_vehicle/actions';
export * from './ambulance/actions';